import { Link, navigate } from 'gatsby';
import { string } from 'prop-types';
import * as React from 'react'
import { useAppSelector } from '../../../hooks/useAppSelector';
import { WeatherSearchKey } from '../../../store/weatherSearchDefaults';
import { MultiLineButton } from '../../shared/base/multiline-button';
import { AppMap } from '../map/map';
import { FormSelect } from './select';
import { TemperatureRange, TemperatureRangeProps } from './temperature-range';

export interface BaseSearchFormProps {
    className?: string;
    delayedRenderId?: string
}

export const WeatherSearchForm = ({ delayedRenderId, className }: BaseSearchFormProps) => {
    const results = useAppSelector(state => {
        return state.weatherSearch.searchResults;
    });


    return (
        <div className={`max-w-[1400px] w-[90vw] mx-auto shadow-standard lg:rounded-l-lg lgmax:rounded-lg flex ${className}`}>
            <div className='flex-auto flex flex-wrap bg-white lg:rounded-l-lg lgmax:rounded-lg px-[20px] ts:px-[30px] py-10 gap-y-6 '>

                <StandardSelect prop='continent' label='Where do you want to go?'></StandardSelect>
                <StandardSelect prop='month' label='When do you want to go?'></StandardSelect>
                <StandardSelect prop='tag' label='What do you want to do?'></StandardSelect>
                <StandardSelect prop='rainseason' label='Season'></StandardSelect>
                <StandardRange isMulti prop='tmax' propTitle='Day temperature' />
                <StandardRange isMulti prop='tmin' propTitle='Night temperature' className={delayedRenderId && 'mdmax:hidden'} />
                <StandardRange isMulti prop='sst' propTitle='Sea temperature' className={delayedRenderId && 'mdmax:hidden'} />
                <StandardRange isMulti={false} prop='wet' useBlue={true} propTitle='Wet days per month' className={delayedRenderId && 'mdmax:hidden'} />
                <WidthWrapper className="px-[16px] self-center m-auto">
                    <Link to="/weather-search/">
                        <MultiLineButton
                            className='w-full leading-loose max-w-[400px] h-full m-auto items-center content-center justify-center'
                            firstLine={"Find holiday"}
                            secondLine={`Explore ${(results || []).length} destinations`}
                            onClick={function (): void {
                            }} />
                    </Link>
                </WidthWrapper>

            </div>
            <div onClick={() => { navigate('/weather-search/') }} className='w-[390px] xxlmax:w-[375px] xlmax:w-[360px] lgmax:hidden shrink-0 bg-transparent relative dark-overlay cursor-pointer'>
                <AppMap fromMainSearchForm={false} delayedRenderId={delayedRenderId} className="rounded-r-lg " />
            </div>

        </div>
    );
}

const StandardRange = ({ isMulti, prop, propTitle, inverted, className, useBlue }: TemperatureRangeProps) => {
    return <WidthWrapper className={`px-[16px] ${className}`}>
        <TemperatureRange prop={prop} propTitle={propTitle} inverted={inverted} isMulti={isMulti} useBlue={useBlue} />
    </WidthWrapper>
}

const StandardSelect = ({ label, prop, className }: { label: string, prop: WeatherSearchKey, className?: string }) => {
    return <WidthWrapper className={`px-[16px] ${className}`}>
        <FormSelect label={label} prop={prop}></FormSelect>
    </WidthWrapper>
}

const WidthWrapper = ({ children, className }: { children: React.ReactNode, className?: string }) => {
    return (
        <div className={`w-full ts:w-1/2 md:w-1/3  ${className}`}>
            {children}
        </div>
    )
}